import _ from 'lodash';
import {
  required, maxValue, minLength, requiredIf,
} from 'vuelidate/lib/validators';
import { getFormattedMemberName } from '@/app/utils/utils';

const relationships = ['Spouse', 'Child', 'Other allowable beneficiary'];

const initBeneficiaryDetails = beneficiaryDetails => (beneficiaryDetails
  ? {
    ...beneficiaryDetails,
    relationship: beneficiaryDetails.relationship || '',
    otherRelationship: beneficiaryDetails.otherRelationship || '',
  }
  : {
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    sex: '',
    dateOfBirth: '',
    relationship: '',
    isMember: false,
    otherRelationship: '',
  });

export default {
  name: 'beneficiary-details',
  props: {
    selectedBeneficiary: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      relationships,
      beneficiary: initBeneficiaryDetails(),
    };
  },
  computed: {
    getItem() {
      return _.cloneDeep(this.$store.getters['toolkit/getItemData']);
    },
    pensions() {
      return this.getItem.pensions;
    },
    activePension() {
      return this.getItem.activePension;
    },
    eligibleMembers() {
      const { members } = this.$store.getters['fund/getFund'];
      return members.filter(member => getFormattedMemberName(member) !== this.selectedMember);
    },
  },
  methods: {
    setItem(data) {
      _.merge(this.pensions[this.activePension], data);
      this.$store.dispatch('toolkit/updateItemKey', { data: { pensions: this.pensions } });
    },
    loadBeneficiaryDetails() {
      // eslint-disable-next-line max-len
      const beneficiaryDetails = this.pensions[this.activePension].reversionaryBeneficiary.beneficiaryDetails || null;
      this.beneficiary = initBeneficiaryDetails(beneficiaryDetails);
    },
    resetOtherRelationship() {
      if (this.beneficiary.relationship !== 'Other allowable beneficiary') {
        this.beneficiary.otherRelationship = '';
      }
    },
  },
  watch: {
    beneficiary: {
      deep: true,
      handler(value) {
        this.resetOtherRelationship();
        this.setItem({ reversionaryBeneficiary: { beneficiaryDetails: value } });
        this.$emit('valid', !this.$v.$invalid);
      },
    },
    selectedBeneficiary(value) {
      if (value !== 'Other' && value !== '') {
        const selectedBeneficiaryMember = this.eligibleMembers.filter(member => (`${member.title} ${member.firstName}${member.middleName !== '' ? ` ${member.middleName}` : ''} ${member.lastName}` === value))[0];
        this.beneficiary = initBeneficiaryDetails(selectedBeneficiaryMember);
      } else {
        this.beneficiary = initBeneficiaryDetails();
      }
      this.setItem({ reversionaryBeneficiary: { beneficiaryDetails: this.beneficiary } });
    },
  },
  mounted() {
    this.loadBeneficiaryDetails();
  },
  validations: {
    beneficiary: {
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      dateOfBirth: {
        required,
        beforeNow: maxValue(new Date()),
      },
      relationship: {
        required,
      },
      otherRelationship: {
        required: requiredIf(vm => (vm.relationship === 'Other allowable beneficiary')),
      },
    },
  },
};
